import { Address } from './address.interface';

export interface Customer {
  id?: number;
  user_id?: number; // Wenn registriert, user->id
  customer_nr_old: string|null;
  customer_type: CustomerType;
  phone?: string;
  mobile?: string;
  email?: string;
  email2?: string;
  birthdate?: string;
  newsletter?: boolean;
  vip?: boolean;
  notes?: string;
  full_customer_number?: string;
}

export interface CustomerWithAddresses extends Customer {
  addresses?: Address[];
}

export interface CustomerWithDefaultAddress extends Customer {
  default_address: Address;
}

export type CustomerType = 'person' | 'club' | 'company' | 'other';

export const CustomerTypeMapper: Record<CustomerType, string> = {
  person: 'Person',
  club: 'Verein',
  company: 'Firma',
  other: 'Sonstiges',
};
